<template>
  <a :href="decode(doc.downloadURL)" class="modal__feature-vendor-doc">
    <div class="h-display-inline">

    <div class="modal__vendor-doc-title">
      <div class="modal__vendor-doc-icon h-display-inline-block"><i class="far fa-file"></i></div>
      <div class="modal__vendor-doc-download h-display-inline-block">{{ doc.title}}</div>
    </div>
    <div class="modal__vendor-doc-description h-display-block" v-html="doc.description"></div>
    </div>
  </a>
</template>

<script>
  import FuelUtilities from "../../utils/FuelUtilities";

  export default {
    name: 'VendorDoc',
    mixins: [FuelUtilities],
    props: ['doc'],
  };
</script>

